// extracted by mini-css-extract-plugin
export default {"dotsMenu":"WideGameDots_dotsMenu--s8q","dot":"WideGameDots_dot--Vf2","dotWrapper":"WideGameDots_dotWrapper--yzw","dotActive":"WideGameDots_dotActive--BIs"};